import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL ?? "http://localhost:8000";
console.log(baseUrl);
const instance = axios.create({
  //baseURL: baseUrl,            // ✅ Important pour que Axios gère bien les URLs
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});


function logout(reload) {
    localStorage.setItem('loggedIn', false);
    localStorage.removeItem('user');
    if (reload)
        document.location.reload();
}

export const Api = {

    get(path, options) {
        return new Promise ((resolve, reject) => {
            instance.get(`${baseUrl}${path}`, options).then((response) => {
                resolve(response);
            }).catch((err) => {
                if (!err.response)
                    console.log(err);
                else if (err.response.status === 401)
                    logout(true);
                reject(err);
            })
        })
    },
    post(path, body, header = { headers: { 'Content-Type': 'application/json' } }) {
        return new Promise ((resolve, reject) => {
            instance.post(`${baseUrl}${path}`, body, header)
            .then((response) => {
                resolve(response);
            }).catch((err) => {
                if (!err.response)
                    console.log(err);
                else if (err.response.status === 401)
                    logout();
                reject(err);
            })
        })
    },
    patch(path, body) {
        return new Promise ((resolve, reject) => {
            instance.patch(`${baseUrl}${path}`, body).then((response) => {
                resolve(response);
            }).catch((err) => {
                if (!err.response)
                    console.log(err);
                else if (err.response.status === 401)
                    logout();
                reject(err);
            })
        })
    },
    delete(path, header) {
        return new Promise ((resolve, reject) => {
            instance.delete(`${baseUrl}${path}`, header).then((response) => {
                resolve(response);
            }).catch((err) => {
                if (!err.response)
                    console.log(err);
                else if (err.response.status === 401)
                    logout();
                reject(err);
            })
        })
    },
}
